import { color } from '@upstox/upstox-ui';

export const container: CSSFunction = ({ cssProps }) => ({
  pointerEvents: cssProps.loading ? 'none' : 'auto',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'space-between',
});

export const button: CSSFunction = ({ theme }) => ({
  border: `1px solid ${color(theme, 'interactive.primary.default')}`,
  borderRadius: '4px',
  color: color(theme, 'interactive.primary.default'),
  cursor: 'pointer',
  fontSize: theme.fontSizes.s,
  fontWeight: theme.fontWeights.normal,
  lineHeight: '20px',
  padding: '8px 16px',
});

export const createButton: CSSFunction = ({ cssProps, theme }) => ({
  borderRadius: '4px',
  backgroundColor: cssProps.disabled
    ? color(theme, 'disabled.3')
    : color(theme, 'interactive.primary.default'),
  color: color(theme, 'text.3'),
  cursor: 'pointer',
  fontSize: theme.fontSizes.s,
  fontWeight: theme.fontWeights.normal,
  lineHeight: '20px',
  padding: '8px 16px',
});

export const text: CSSFunction = ({ theme }) => ({
  width: '208px',
  color: color(theme, 'text.2'),
  lineHeight: '16px',
  fontSize: theme.fontSizes.s,
  fontWeight: theme.fontWeights.normal,
});
